module.exports = __webpack_public_path__ + "img/15.a6b64bc5.png";